module.exports = __webpack_public_path__ + "static/media/youtube-logo.23b6c2ec.svg";